import {TrueGritStatics} from "../../TrueGritStatics";
import {ISymbol, ISymbolPosition} from "../../../core/reel/ReelInterfaces";
import {TrueGritSymbol, TrueGritSymbolStates} from "../../reels/TrueGritSymbol";
import {gsap, TimelineLite} from "gsap";
import {TrueGrit} from "../../TrueGrit";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

/**
 * Created by Jerker Nord on 2021-07-08.
 */

export class TrueGritTopReelView extends PIXI.Container implements StageLayer {

    private readonly _reelId:number;

    private _allInSymbols:ISymbol[] = [];
    private _allOutSymbols:ISymbol[] = [];
    private _collapsedReel:ISymbol[] = [];
    private _shouldFillUp:boolean = false;

    constructor() {
        super();

        this.name = "Reel 6"
        this._reelId = 6;
    }

    onResize():void {
        this.position = TrueGritStatics.TOP_REEL_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }

    public clear(){

        while (this._allInSymbols.length > 0) {
            const sym = this._allInSymbols.pop();
            if (sym){
                this.removeAvalancheSymbol(sym);
            }
        }
        while (this._allOutSymbols.length > 0) {
            const sym = this._allOutSymbols.pop();
            if (sym){
                this.removeAvalancheSymbol(sym);
            }
        }
        while (this._collapsedReel.length > 0) {
            const sym = this._collapsedReel.pop();
            if (sym){
                this.removeAvalancheSymbol(sym);
            }
        }
    }

    public initReel(symbols:string[], isAvalancheRestore:boolean):void {
        this._shouldFillUp = isAvalancheRestore;

        for(let i:number = 0; i < symbols.length; i++) {
            if(isAvalancheRestore == false) {
                const symbol:ISymbol = this.createSymbol(symbols[i], TrueGritSymbolStates.NORMAL, {
                    reelId : 6,
                    startPosition : i + 1,
                    targetPosition : i + 1
                });
                this._allOutSymbols.push(symbol);
            } else {
                const symbol:ISymbol = this.createSymbol(symbols[i], TrueGritSymbolStates.NORMAL, {
                    reelId : 6,
                    startPosition : i + 1,
                    targetPosition : i + 1
                });
                if(TrueGrit.model.initData.greatBookOfWays[1 + i][0] > 1) {
                    (<TrueGritSymbol>symbol).splitLevel = TrueGrit.model.initData.greatBookOfWays[1 + i][0];
                    (<TrueGritSymbol>symbol).setCurrentStateSpriteTexture();
                }
                this._collapsedReel.push(symbol);
            }
        }

        this.onResize();
    }

    public getSymbolBySymbolPosition(position:number):ISymbol {
        for(let i:number = 0; i < this._allOutSymbols.length; i++) {
            if(this._allOutSymbols[i].reelTargetPosition == position) {
                return this._allOutSymbols[i];
            }
        }
        throw new Error("True grit top reel: Symbol at position " + position + " not found");
    }

    public createSymbol(symbolName:string, state:TrueGritSymbolStates, symbolPositionData:ISymbolPosition):ISymbol {
        //const symbolState:TrueGritSymbolStates = state == SimpleReelModelState.SPIN || state == SimpleReelModelState.STOP ? TrueGritSymbolStates.SPIN : TrueGritSymbolStates.NORMAL;
        const symbol:TrueGritSymbol = new TrueGritSymbol(symbolName).init(state);
        symbol.position.set((symbolPositionData.startPosition * TrueGritStatics.symbolWidth), 0);
        symbol.reelTargetPosition = symbolPositionData.targetPosition;
        symbol.reelPosition = symbolPositionData.startPosition;
        this.addChild(symbol);
        return symbol;
    }

    public getAllOutAnimation():TimelineLite {
        const returnTimeline:gsap.core.Timeline = gsap.timeline();
        let timeline:gsap.core.Timeline;
        const subTimelines:gsap.core.Timeline[] = [];
        let counter:number = 3;
        while(this._allOutSymbols.length > 0) {
            const symbol:TrueGritSymbol = <TrueGritSymbol>this._allOutSymbols.pop()!;
            symbol.reelTargetPosition = 4;
            if(symbol == null) {
                debugger;
                throw new Error(`AvalancheReelPartAnimator.animateAllOut, symbol is null!`);
            } else {
                timeline = gsap.timeline();
                timeline.add([
                    gsap.timeline({delay : TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.topReelAllOutBlurDelayFastSpin + (counter * 0.03) : (TrueGritStatics.topReelAllOutBlurDelay + (counter * 0.01))}).add((<TrueGritSymbol>symbol).getStateAnimation(TrueGritSymbolStates.SPIN_HORIZONTAL, 0.2)),
                    gsap.to(symbol.position, {
                        duration : TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.topReelAllOutTotalSpinDurationFastSpin : TrueGritStatics.topReelAllOutTotalSpinDuration,
                        x : symbol.position.x - (TrueGritStatics.symbolWidth * (symbol.reelTargetPosition - 1) + 60),
                        ease : "sine.in",
                        delay : TrueGritStatics.topReelSpinStartSymbolDelay * counter
                    })
                ]);

                timeline.add(() => this.removeAvalancheSymbol(symbol));
                subTimelines.push(timeline);
            }
            counter--;
        }
        returnTimeline.add(subTimelines);
        return returnTimeline;
    }

    public getFillUpReelAnimation():gsap.core.Timeline {
        if(this._shouldFillUp == true) {
            this._shouldFillUp = false;
            let numberOfFillUpSymbols:number = 3 - this._collapsedReel.length;
            for(let i:number = 0; i < numberOfFillUpSymbols; i++) {
                const symbol:ISymbol = this.createSymbol(TrueGrit.model.gameData.topTrain.beforeSpellSymbols[(3 - numberOfFillUpSymbols) + i], TrueGritSymbolStates.SPIN_HORIZONTAL, {
                    reelId : 6,
                    startPosition : 4 + i,
                    targetPosition : (3 - numberOfFillUpSymbols) + i + 1
                });
                this._collapsedReel.push(symbol);
            }
            return this.getFillUpAnimation();
        }
        return gsap.timeline();
    }

    private getFillUpAnimation():gsap.core.Timeline {
        const fillUpTimeline:gsap.core.Timeline = gsap.timeline();
        let timeline:gsap.core.Timeline;
        const subTimelines:gsap.core.Timeline[] = [];
        let counter:number = 0;
        this._allOutSymbols = [];
        this._collapsedReel.reverse();
        while(this._collapsedReel.length > 0) {
            const symbol:ISymbol = this._collapsedReel.pop()!;
            this._allOutSymbols.unshift(symbol);
            if(symbol == null) {
                debugger;
                throw new Error(`AvalancheReelPartAnimator.animateFillUp, symbol is null!`);
            } else {
                if(symbol.reelTargetPosition < symbol.reelPosition) {
                    timeline = gsap.timeline();
                    timeline.add([
                        () => {
                            if(symbol.reelPosition - symbol.reelTargetPosition > 1) {
                                gsap.timeline({delay : 0.1}).add((<TrueGritSymbol>symbol).getStateAnimation(TrueGritSymbolStates.LANDING, 0.2))
                            }else{
                                gsap.timeline().add((<TrueGritSymbol>symbol).getStateAnimation(TrueGritSymbolStates.LANDING, 0))
                            }
                        },
                        gsap.to(symbol.position, {
                            duration : 0.1 * (symbol.reelPosition - symbol.reelTargetPosition),
                            x : TrueGritStatics.symbolWidth * symbol.reelTargetPosition,
                            ease : "power3.in",
                            delay : TrueGritStatics.topReelSpinFillUpSymbolDelay * counter
                        })
                    ]);
                    timeline.add(() => {symbol.reelPosition = symbol.reelTargetPosition});
                    subTimelines.push(timeline);
                }
            }
            counter++;
        }
        fillUpTimeline.add(()=>TrueGrit.soundPlayer.playTrainReelInSound());
        fillUpTimeline.add(subTimelines, "+=0.2");
        fillUpTimeline.add(() => TrueGrit.soundPlayer.playTrainReelStopSound());
        fillUpTimeline.add(() => {this._allOutSymbols = this.sortSymbolArray(this._allOutSymbols)});
        return fillUpTimeline;
    }

    /**
     * Calculates which symbols that should move to the left and how many steps
     */
    public collapseTopReel():gsap.core.Timeline {
        this._collapsedReel = [];
        for(let i:number = 0; i < this._allOutSymbols.length; i++) {
            if(this._allOutSymbols[i].isRemoved == true) {
                this.removeAvalancheSymbol(this._allOutSymbols[i]);
                this._shouldFillUp = true;
                // If i = 3 it's the far right symbol which should not move
                if(i < 3) {
                    for(let j:number = (i + 1); j < this._allOutSymbols.length; j++) {
                        if(this._allOutSymbols[j].isRemoved == false) {
                            this._allOutSymbols[j].reelTargetPosition--;
                        }
                    }
                }
            } else {
                this._collapsedReel.push(this._allOutSymbols[i]);
            }
        }
        return this.getTopReelCollapseAnimation();
    }

    private getTopReelCollapseAnimation():gsap.core.Timeline {
        const collapseTimeline:gsap.core.Timeline = gsap.timeline();
        let timeline:gsap.core.Timeline;
        const subTimelines:gsap.core.Timeline[] = [];
        for(let i:number = 0; i < this._allOutSymbols.length; i++) {
            const symbol:TrueGritSymbol = <TrueGritSymbol>this._allOutSymbols[i];
            if(symbol.reelTargetPosition < symbol.reelPosition) {
                timeline = gsap.timeline();
                timeline.add([
                    gsap.to(symbol.position, {
                        duration : 0.1 * (symbol.reelPosition - symbol.reelTargetPosition),
                        x : (TrueGritStatics.symbolWidth * symbol.reelTargetPosition),
                        ease : "power3.in",
                        delay : TrueGritStatics.topReelSpinStopSymbolDelay * i
                    })]);
                timeline.add(() => {symbol.reelPosition = symbol.reelTargetPosition});
                subTimelines.push(timeline);
            }
        }

        collapseTimeline.add(subTimelines);

        if(collapseTimeline.duration() == 0) {
            collapseTimeline.add(gsap.to(this, {duration : 0.001}));
        }
        return collapseTimeline;
    }

    public getAllInAnimation():gsap.core.Timeline {
        const returnTimeline:gsap.core.Timeline = gsap.timeline();
        let timeline:gsap.core.Timeline;
        const subTimelines:gsap.core.Timeline[] = [];
        let counter:number = 0;
        this._allOutSymbols = [];
        while(this._allInSymbols.length > 0) {
            const symbol:ISymbol = this._allInSymbols.pop()!;
            this._allOutSymbols.push(symbol);
            if(symbol == null) {
                debugger;
                throw new Error(`AvalancheReelPartAnimator.animateAllIn, symbol is null!`);
            } else {
                timeline = gsap.timeline({delay : TrueGritStatics.topReelSpinStopSymbolDelay * counter});
                timeline.add([
                    gsap.timeline({delay : TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.topReelAllInBlurDelayFastSpin : TrueGritStatics.topReelAllInBlurDelay}).add((<TrueGritSymbol>symbol).getStateAnimation(TrueGritSymbolStates.LANDING, 0.1)),
                    gsap.to(symbol.position, {
                        duration : TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.topReelAllInTotalSpinDurationFastSpin : TrueGritStatics.topReelAllInTotalSpinDuration,
                        x : (symbol.reelTargetPosition * TrueGritStatics.symbolWidth),
                        ease : "sine.in"
                    })
                ]);
                timeline.add(() => {symbol.reelPosition = symbol.reelTargetPosition});
                timeline.add(() => this.symbolLanding(symbol));
                subTimelines.push(timeline);
            }
            counter++;
        }
        returnTimeline.add(()=>TrueGrit.soundPlayer.playTrainReelInSound());
        returnTimeline.add(subTimelines);
        return returnTimeline;
    }

    public stop(reelData:string[]):TimelineLite {
        for(let i:number = 0; i < reelData.length; i++) {
            const symbol:ISymbol = this.createSymbol(reelData[i], TrueGritSymbolStates.SPIN_HORIZONTAL, {
                reelId : 6,
                startPosition : 4 + i,
                targetPosition : i + 1
            });
            this._allInSymbols.unshift(symbol);
        }

        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(this.getAllInAnimation());

        return tl;
    }

    private symbolLanding(symbol:ISymbol):void {
        (<TrueGritSymbol>symbol).getStateAnimation(TrueGritSymbolStates.LANDING);
    }

    private sortSymbolArray(toBeSorted:ISymbol[]):ISymbol[] {
        const sortedSymbols:ISymbol[] = [];
        for(let i:number = 1; i < 4; i++) {
            for(let j:number = 0; j < toBeSorted.length; j++) {
                if(toBeSorted[j].reelPosition == i) {
                    sortedSymbols.push(toBeSorted[j]);
                    break;
                }
            }
        }
        return sortedSymbols;
    }

    public removeAvalancheSymbol(symbol:ISymbol) {
        this.removeChild(<TrueGritSymbol>symbol);
        (<TrueGritSymbol>symbol).destroy({children : true});
    }

    public getAllSymbols(): ISymbol[] {
        return this._allOutSymbols;
    }
}